module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"currentStateTitle":"Aktueller Zustand","viewOnly":"Nur Ansicht"}}')
  delete Component.options._Ctor
}
